{
    "UserTour_Next": "Suivant",
    "UserTour_Cancel": "Montrez-moi plus tard",
    "UserTour_Exit": "Désactiver la visite",
    "NAME": "UserTour"
}